module.exports = __webpack_public_path__ + "static/media/calm_slightly-happy.b9df18e5.svg";